import { render, staticRenderFns } from "./Contributions.vue?vue&type=template&id=e70c12fa&scoped=true&"
import script from "./Contributions.vue?vue&type=script&lang=js&"
export * from "./Contributions.vue?vue&type=script&lang=js&"
import style0 from "./Contributions.vue?vue&type=style&index=0&id=e70c12fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70c12fa",
  null
  
)

export default component.exports